import classNames from "classnames";
import { TaskTemplateDeadlineAnchor } from "@common/types/taskTemplate";
import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerSectionData } from "@design-system/Picker/Picker.types";
import { DescriptionListItem } from "@design-system/DescriptionList/DescriptionList";
import taskStyles from "@components/drawers/TaskDrawerFields.module.scss";
import {
    formatDeadlineHeaderLabel,
    formatDeadlineLabel,
    getDeadlineOptions,
} from "./closeTemplateTasksDrawer.constants";

const NO_DEADLINE_VALUE = "__no_deadline__";

interface Props {
    value: number | null;
    anchor: TaskTemplateDeadlineAnchor | null;
    onChange: (value: number | null) => void;
}

export const DeadlineField = ({ value, anchor, onChange }: Props) => {
    const selectValue = value !== null ? value.toString() : NO_DEADLINE_VALUE;
    const sections: Array<PickerSectionData<string>> = [
        {
            key: "deadline",
            title: formatDeadlineHeaderLabel(anchor),
            items: [
                { value: NO_DEADLINE_VALUE, label: "None" },
                ...getDeadlineOptions(value).map((days) => ({
                    value: days.toString(),
                    label: formatDeadlineLabel(days),
                })),
            ],
        },
    ];

    return (
        <DescriptionListItem label="Due">
            <div className={taskStyles.detailSelectWrapper}>
                <Picker.Select
                    sections={sections}
                    value={selectValue}
                    onValueChange={(v) => {
                        onChange(
                            v === null || v === NO_DEADLINE_VALUE
                                ? null
                                : Number(v),
                        );
                    }}
                    trigger={
                        <Picker.Button
                            variant="primary"
                            className={classNames(
                                taskStyles.detailSelectTrigger,
                                {
                                    [taskStyles.emptyValue]: value === null,
                                },
                            )}
                        />
                    }
                />
            </div>
        </DescriptionListItem>
    );
};
